
import requestModule from '@/assets/libs/requestModule'
import store from '@/store/index.js'
import md5 from 'md5'

const registerConsumer = async (data) => {
  try {
    data.password = md5(`odhen${data.password}7833`)
    const response = await requestModule.postRequest('consumer/create', data)
    return response
  } catch (error) {
    const message = error?.response?.data?.message || 'Erro ao cadastrar usuário'
    return {
      error: true,
      message
    }
  }
}

const changePassword = async (oldPassword, newPassword) => {
  const data = {
    oldPassword: md5(`odhen${oldPassword}7833`),
    newPassword: md5(`odhen${newPassword}7833`)
  }

  try {
    const response = await requestModule.postRequest('consumer/change-password', data)
    return response
  } catch (error) {
    const message = error?.response?.data?.message || 'Erro ao atualizar senha'
    return {
      error: true,
      message
    }
  }
}

const changeProfileData = async (data) => {
  try {
    const response = await requestModule.postRequest('consumer/change-profile-data', data)

    if (!response.error) {
      store.dispatch('updateUserProfile', data)
    }

    return response
  } catch (error) {
    const message = error?.response?.data?.message || 'Erro ao atualizar dados'
    return {
      error: true,
      message
    }
  }
}

const sendOtp = async ({ email, phone }) => {
  try {
    const response = await requestModule.postRequest('consumer/send-otp-login', {
      email,
      phone
    })
    return response
  } catch (error) {
    const message = error?.response?.data?.message || 'Erro ao enviar código'
    return {
      error: true,
      message
    }
  }
}

const validateOtp = async ({ email, code }) => {
  try {
    const response = await requestModule.postRequest('consumer/otp-login', {
      email,
      otp: code
    })
    return response
  } catch (error) {
    const message = error?.response?.data?.message || 'Código inválido ou expirado'
    return {
      error: true,
      message
    }
  }
}

export { registerConsumer, changePassword, changeProfileData, sendOtp, validateOtp }
